<template>
  <Bread-crumb page="Beranda > Pendaftaran > Tahun Ajaran > Lihat Template Email"></Bread-crumb>
  <div class="container content-area">
    <div class="row">
      <div class="col-12">
        <h3 class="judul-seksi-sga">Template Email</h3>
        <div class="card">
          <DataTable ref="dt"
                     :value="dataJenisSurat"
                     v-model:selection="selectedTemplate"
                     :loading="loading"
                     :paginator="true"
                     :rows="10"
                     :filters="filters"
                     paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                     :rowsPerPageOptions="[5,10,25]"
                     currentPageReportTemplate="Tampil {first} dari {last} of {totalRecords} data periode"
                     :globalFilterFields="['tahun_ajaran', 'statusinfo']"
                     class="p-datatable-sm"
                     stripedRows
          >
            <template #paginatorend>
            </template>
            <template #empty> Tidak ada data. </template>
            <template #loading> Mengambil data. Silakan tunggu. </template>
            <Column field="jenis_surat" header="Jenis Surat" sortable style="min-width:12rem"></Column>
            <Column field="tagname" header="Slug" sortable style="min-width:12rem"></Column>
            <Column :exportable="false" header="Lihat"  style="min-width:8rem">
              <template #body="item">
                <Button v-if="item.data.preview" icon="pi pi-eye" size="small" class="mr-2" @click="viewPreview(item)"/>
              </template>
            </Column>
            <Column :exportable="false" header="Action"  style="min-width:8rem">
              <template #body="item">
                <Button icon="pi pi-pencil" size="small" class="mr-2" @click="viewEdit(item)"/>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
  <Dialog v-model:visible="view.preview" :style="{width: '1000px'}" :header=dialogheader :modal="true" class="p-fluid">
    <div v-html="content"></div>
  </Dialog>
  <Dialog v-model:visible="view.edit" :style="{width: '1000px'}" :header=dialogheader :modal="true" class="p-fluid">
    <PageUploadFileSurat
    :data="editSurat"
    :tag="dataTag"
    @update="updateTemplateSurat"
    />
  </Dialog>
</template>

<script>
import 'primeicons/primeicons.css';
import BreadCrumb from "@/components/BreadCrumb";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import useValidate from '@vuelidate/core'
import {FilterMatchMode} from "@primevue/core/api";
import DashboardServices from "@/services/dashboard.services";
import PageUploadFileSurat from "@/components/viewadmin/tahunajaran/PageUploadFileSurat";
export default {
  name: "PageTemplateEmail",
  components:{PageUploadFileSurat, BreadCrumb,DataTable,Column,Dialog,Button},
  data:()=>({
    v$: useValidate(),
    loading: false,
    response: '',
    message:'',
    success:false,
    successtrx: false,
    dataJenisSurat:[],
    selectedTemplate:[],
    dialogheader:"",
    content:"",
    editSurat:[],
    dataTag:[],
    view:{
      preview: false,
      edit: false,
    },
    filters: {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    },
    messagetrx:'',
    error:'',
  }),
  methods:{
    viewPreview(item){
      this.dialogheader = item.data.jenis_surat;
      this.editSurat = item.data;
      this.view.edit = false;
      this.view.preview = true;
      this.content = atob(item.data.viewsurat)
    },
    viewEdit(item){
      this.dialogheader = item.data.jenis_surat;
      this.editSurat = item.data;
      this.view.edit = true;
      this.view.preview = false;
      this.content = "";
    },
    getDataJenisSurat(){
      this.loading = true;
      let data = {};
      let path = '/dashboard/getDataJenisSurat';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataJenisSurat = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
    getDataTag(){
      this.loading = true;
      let data = {};
      let path = '/dashboard/getAvaliableParameterTag';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataTag = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },
    updateTemplateSurat(emitdata){
      this.loading = true;
      let data = emitdata;
      let path = '/dashboard/getDataUpdateJenisSurat';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataJenisSurat = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    }
  },
  mounted() {
    this.getDataJenisSurat();
    this.getDataTag();
  }
}
</script>

<style scoped>

</style>